/* amatora-variants-sheet.js
   JS del selector de variantes que se abre desde las cards. El HTML, el contrato del
   disparador y la documentación viven en snippets/amatora-variants-sheet.liquid. */
(function () {
  var root = document.getElementById('am-variants');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  var panel = root.querySelector('.amv-am__panel');
  var optsEl = root.querySelector('[data-amv-options]');
  var titleEl = root.querySelector('[data-amv-title]');
  var priceEl = root.querySelector('[data-amv-price]');
  var compareEl = root.querySelector('[data-amv-compare]');
  var imgEl = root.querySelector('[data-amv-img]');
  var addBtn = root.querySelector('[data-amv-add]');
  var addLabel = addBtn.querySelector('.btn-label');
  var moreEl = root.querySelector('[data-amv-more]');

  var SIZES = {};
  try { SIZES = JSON.parse(root.querySelector('[data-amv-sizes]').textContent || '{}') || {}; } catch (e) { SIZES = {}; }

  var TELAS = { map: {}, solo: {} };
  try { TELAS = JSON.parse(root.querySelector('[data-amv-telas]').textContent || '{}') || TELAS; } catch (e) {}
  TELAS.map = TELAS.map || {}; TELAS.solo = TELAS.solo || {};

  // Mismo formato que el filtro money de la tienda
  var MONEY_FMT = root.dataset.moneyFormat || '${{amount}}';
  function money(cents, trim) {
    var parts = (cents / 100).toFixed(2).split('.');
    var int = parts[0], dec = parts[1];
    var sep = function (s) { return int.replace(/\B(?=(\d{3})+(?!\d))/g, s); };
    var out = MONEY_FMT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      return ({
        amount: sep(',') + '.' + dec,
        amount_no_decimals: sep(','),
        amount_with_comma_separator: sep('.') + ',' + dec,
        amount_no_decimals_with_comma_separator: sep('.'),
        amount_with_space_separator: sep(' ') + ',' + dec,
        amount_no_decimals_with_space_separator: sep(' '),
        amount_with_apostrophe_separator: sep("'") + '.' + dec
      })[k] || sep(',') + '.' + dec;
    });
    return trim ? out.replace(/[.,]00(?!\d)/, '') : out;
  }

  // Muestra de tela para un valor ("Ivory / Treviso"), o null
  function telaFor(value) {
    var k = key(value);
    if (TELAS.map[k]) return TELAS.map[k];
    var solo = state && state.handle && TELAS.solo[state.handle];
    if (solo && k.indexOf('/') === -1) return TELAS.map[k + ' / ' + solo] || null;
    return null;
  }

  // ---- Variantes bajo demanda: /products/<handle>.js, una vez por producto ----
  var cache = {};
  function jsUrl(url) { return String(url || '').split('?')[0].split('#')[0] + '.js'; }
  function handleOf(url) { var m = String(url || '').split('?')[0].match(/\/products\/([^\/]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function load(btn) {
    var u = btn.dataset.productUrl;
    if (!u) return Promise.reject(new Error('sin data-product-url'));
    var k = jsUrl(u);
    if (!cache[k]) {
      cache[k] = fetch(k, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product.js ' + r.status); return r.json(); })
        .catch(function (err) { delete cache[k]; throw err; });
    }
    return cache[k];
  }
  function fromProductJs(p, trim) {
    var options = (p.options || []).map(function (o) { return { name: o.name, values: (o.values || []).slice() }; });
    var variants = (p.variants || []).map(function (v) {
      var img = v.featured_image && v.featured_image.src;
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
      return {
        id: v.id,
        title: v.title,
        options: Array.isArray(v.options) ? v.options : [v.title],
        price: money(v.price, trim),
        cents: v.price,
        compare_at_price: v.compare_at_price && v.compare_at_price > v.price ? money(v.compare_at_price, trim) : null,
        available: !!v.available,
        img: img || null
      };
    });
    return { options: options, variants: variants };
  }
  // Adelanta la descarga cuando el dedo o el cursor llegan al botón
  function prefetch(e) {
    var t = e.target instanceof Element ? e.target.closest('[data-am-variants]') : null;
    if (t && !t.dataset.variants) load(t).catch(function () {});
  }
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);

  var RE_SIZE = /tama|size|medida/i;
  var RE_SHIP = /env[ií]o|entrega|shipping/i;

  var state = null; // { options, variants, sel: [], url, fallbackImg }
  var lastTrigger = null;
  var closeTimer = null;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function key(v) { return String(v == null ? '' : v).toLowerCase().trim(); }

  // Variante exacta para una selección
  function findVariant(sel) {
    for (var i = 0; i < state.variants.length; i++) {
      var v = state.variants[i], ok = true;
      for (var j = 0; j < sel.length; j++) { if (v.options[j] !== sel[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  // Estado de un valor: 'ok' | 'soldout' | 'missing' con el resto de la selección
  function valueStatus(idx, value) {
    var sel = state.sel.slice(); sel[idx] = value;
    var v = findVariant(sel);
    if (!v) return { status: 'missing', variant: null };
    return { status: v.available ? 'ok' : 'soldout', variant: v };
  }
  // Mejor variante con option[idx] = value: la que más opciones comparte, disponible primero
  function bestWith(idx, value) {
    var best = null, bestScore = -1;
    state.variants.forEach(function (v) {
      if (v.options[idx] !== value) return;
      var score = v.available ? 100 : 0;
      state.sel.forEach(function (s, j) { if (j !== idx && v.options[j] === s) score += 1; });
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  }
  // Cascada (como la tienda nativa): una opción solo ofrece los valores que existen y
  // están disponibles con lo elegido en las opciones ANTERIORES. Elegir un tamaño nunca
  // cambia el envío por detrás.
  function anyAvailable() { return state.variants.some(function (v) { return v.available; }); }
  function candidates(idx, value) {
    var all = anyAvailable();
    return state.variants.filter(function (v) {
      if (v.options[idx] !== value) return false;
      for (var k = 0; k < idx; k++) if (v.options[k] !== state.sel[k]) return false;
      return v.available || !all;
    });
  }
  function pickFor(idx, value) {
    var list = candidates(idx, value);
    var score = function (v) { var n = 0; for (var k = idx + 1; k < v.options.length; k++) if (v.options[k] === state.sel[k]) n++; return n; };
    return list.sort(function (a, b) { return score(b) - score(a); })[0] || null;
  }
  // Precio a mostrar en una tarjeta de tamaño
  function sizePrice(idx, value) {
    var v = pickFor(idx, value);
    return v ? v.price : '';
  }

  // "80x40cm" → "80 × 40 cm" (igual que en la página de producto)
  function niceSize(v) {
    var m = String(v).replace(/\s/g, '').match(/^(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)(cm)?$/i);
    return m ? m[1] + ' × ' + m[2] + ' cm' : v;
  }

  // Dimensiones para la silueta: de la medida (guía de tamaños) o del propio valor ("80x40cm").
  // Siempre en vertical: el lado largo hacia arriba, igual que en la página de producto.
  function dimsOf(value) {
    var src = SIZES[key(value)] || value;
    var clean = String(src).toLowerCase().replace(/\s|cm/g, '').replace('×', 'x');
    // Un solo número ("80cm", espejos circulares): diámetro → misma medida en ambos lados
    var one = clean.match(/^(\d+(?:\.\d+)?)$/);
    if (one) return { w: parseFloat(one[1]), h: parseFloat(one[1]) };
    var m = clean.match(/^(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)$/);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    return { w: Math.min(a, b), h: Math.max(a, b) };
  }

  function optionTitle(name) { return RE_SHIP.test(name) ? 'Envío a:' : name; }

  function render() {
    optsEl.innerHTML = '';
    state.options.forEach(function (opt, idx) {
      var group = el('div', 'flex-amatora flex-col-amatora gap-3-amatora');
      var headId = 'amv-opt-' + idx;
      var head = el('p', 'text-sm-amatora text-muted-amatora m-0-amatora');
      head.id = headId;
      var t = optionTitle(opt.name);
      var strong = el('span', 'font-semibold-amatora', t + (/[?:]$/.test(t) ? ' ' : ': '));
      head.appendChild(strong);
      head.appendChild(el('span', null, RE_SIZE.test(opt.name) ? niceSize(state.sel[idx] || '') : (state.sel[idx] || '')));
      group.appendChild(head);

      // Solo los valores válidos con lo elegido antes; con uno solo, es informativo
      var shownVals = opt.values.filter(function (value) { return candidates(idx, value).length > 0; });
      if (shownVals.length <= 1) { optsEl.appendChild(group); return; }

      var isSize = RE_SIZE.test(opt.name);
      var isTela = !isSize && shownVals.every(function (value) { return !!telaFor(value); });
      // Tamaños en 3 columnas (más compacto); con solo 2 tamaños, 2 columnas
      var cols = shownVals.length === 2 ? 'grid-cols-2-amatora' : 'grid-cols-3-amatora';
      var list = el('div', isSize ? 'amv-am__sizes grid-amatora ' + cols + ' gap-2-amatora' : 'flex-amatora flex-wrap-amatora gap-2-amatora');

      // Telas: sobreprecio de cada tela sobre la más barata (solo con precios en centavos)
      var groupMin = {}, allMin = null;
      if (isTela) shownVals.forEach(function (value) {
        var v = pickFor(idx, value);
        if (!v || typeof v.cents !== 'number') return;
        var g = value.indexOf(' / ') > -1 ? value.split(' / ').pop() : '';
        if (groupMin[g] == null || v.cents < groupMin[g]) groupMin[g] = v.cents;
        if (allMin == null || v.cents < allMin) allMin = v.cents;
      });
      var prevGroup = null;
      list.setAttribute('role', 'radiogroup');
      list.setAttribute('aria-labelledby', headId);

      // Escala común de las siluetas: la medida más grande de los tamaños visibles
      var maxW = 0, maxH = 0;
      if (isSize) shownVals.forEach(function (value) {
        var d = dimsOf(value);
        if (d) { maxW = Math.max(maxW, d.w); maxH = Math.max(maxH, d.h); }
      });

      shownVals.forEach(function (value) {
        var selected = state.sel[idx] === value;
        if (isTela && value.indexOf(' / ') > -1) {
          var gName = value.split(' / ').pop();
          if (gName !== prevGroup) {
            var gh = el('span', 'w-full-amatora text-xs-amatora uppercase-amatora tracking-wider-amatora text-muted-light-amatora' + (prevGroup !== null ? ' mt-2-amatora' : ''), gName);
            if (allMin != null && groupMin[gName] > allMin) {
              gh.appendChild(document.createTextNode(' '));
              gh.appendChild(el('span', 'font-semibold-amatora text-primary-amatora', '+' + money(groupMin[gName] - allMin, state.trim)));
            }
            list.appendChild(gh);
            prevGroup = gName;
          }
        }
        if (isTela) {
          var sw = el('button', 'amv-am__swatch block-amatora rounded-full-amatora overflow-hidden-amatora cursor-pointer-amatora');
          sw.type = 'button';
          sw.setAttribute('role', 'radio');
          sw.setAttribute('aria-checked', selected ? 'true' : 'false');
          sw.setAttribute('aria-label', value);
          sw.title = value;
          sw.tabIndex = selected ? 0 : -1;
          if (selected) sw.classList.add('is-selected');
          sw.dataset.idx = idx;
          sw.dataset.value = value;
          var im = el('img', 'block-amatora w-full-amatora h-full-amatora object-cover-amatora');
          im.src = telaFor(value);
          im.alt = '';
          im.width = 40;
          im.height = 40;
          sw.appendChild(im);
          list.appendChild(sw);
          return;
        }
        var b = el('button', isSize
          ? 'amv-am__size flex-amatora flex-col-amatora items-start-amatora gap-1-amatora p-2-amatora text-left-amatora cursor-pointer-amatora'
          : 'amv-am__pill inline-flex-amatora items-center-amatora px-4-amatora py-2-amatora text-sm-amatora cursor-pointer-amatora');
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', selected ? 'true' : 'false');
        b.tabIndex = selected ? 0 : -1;
        if (selected) b.classList.add('is-selected');
        b.dataset.idx = idx;
        b.dataset.value = value;

        if (isSize) {
          var dm = dimsOf(value);
          if (dm && maxW && maxH) {
            var scale = el('span', 'amv-am__scale flex-amatora items-end-amatora mb-1-amatora');
            scale.setAttribute('aria-hidden', 'true');
            scale.style.aspectRatio = maxW + ' / ' + maxH;
            var shape = el('span', 'amv-am__shape shape-am--' + (state.shape || 'rect') + ' block-amatora');
            shape.style.width = (dm.w / maxW * 100) + '%';
            shape.style.height = (dm.h / maxH * 100) + '%';
            scale.appendChild(shape);
            b.appendChild(scale);
          }
          b.appendChild(el('span', 'amv-am__size-name text-sm-amatora font-semibold-amatora', niceSize(value)));
          var measure = SIZES[key(value)];
          if (measure) b.appendChild(el('span', 'text-xs-amatora text-muted-light-amatora', measure));
          var sp = sizePrice(idx, value);
          if (sp) b.appendChild(el('span', 'text-xs-amatora font-semibold-amatora text-muted-amatora', sp));
          var aria = value + (measure ? ', ' + measure : '') + (sp ? ', ' + sp : '');
          b.setAttribute('aria-label', aria);
        } else {
          b.appendChild(el('span', 'amv-am__pill-name', value));
        }
        list.appendChild(b);
      });
      group.appendChild(list);
      optsEl.appendChild(group);
    });
    update();
  }

  function update() {
    var v = findVariant(state.sel);
    var shown = v || state.variants[0];
    priceEl.textContent = shown ? shown.price : '';
    if (shown && shown.compare_at_price) {
      compareEl.textContent = shown.compare_at_price;
      compareEl.hidden = false;
    } else {
      compareEl.hidden = true;
    }
    var img = (v && v.img) || state.fallbackImg || (shown && shown.img);
    if (img) { imgEl.src = img; imgEl.hidden = false; } else { imgEl.hidden = true; imgEl.removeAttribute('src'); }

    addBtn.removeAttribute('data-state');
    if (v && v.available) {
      addBtn.disabled = false;
      addBtn.setAttribute('data-add-to-cart', '');
      addBtn.setAttribute('data-variant-id', v.id);
      addLabel.textContent = 'Agregar al carrito';
    } else {
      addBtn.disabled = true;
      addBtn.removeAttribute('data-add-to-cart');
      addBtn.removeAttribute('data-variant-id');
      addLabel.textContent = v ? 'Agotado' : 'No disponible';
    }
    var url = state.url || '#';
    if (v && url !== '#') url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id;
    moreEl.setAttribute('href', url);
  }

  function choose(idx, value) {
    state.sel[idx] = value;
    // Las opciones posteriores que ya no sean válidas pasan a su primer valor válido
    for (var k = idx + 1; k < state.options.length; k++) {
      if (candidates(k, state.sel[k]).length) continue;
      var first = state.options[k].values.filter(function (val) { return candidates(k, val).length; })[0];
      if (first !== undefined) state.sel[k] = first;
    }
    var v = findVariant(state.sel);
    if (!v || (!v.available && anyAvailable())) {
      var b = bestWith(idx, value);
      if (b) state.sel = b.options.slice();
    }
    render();
    var again = optsEl.querySelector('[data-idx="' + idx + '"][aria-checked="true"]');
    if (again) again.focus({ preventScroll: true });
  }

  function parse(str, fallback) {
    try { var d = JSON.parse(str || ''); return d == null ? fallback : d; } catch (e) { return fallback; }
  }

  // Sin JSON incrustado: pide las variantes y luego abre. Si falla, manda a la ficha.
  function open(btn) {
    if (btn.dataset.variants) { show(btn, parse(btn.dataset.variants, []), parse(btn.dataset.options, [])); return; }
    if (btn.dataset.state === 'loading') return;
    btn.dataset.state = 'loading';
    load(btn).then(function (p) {
      btn.removeAttribute('data-state');
      var d = fromProductJs(p, btn.hasAttribute('data-money-trim'));
      show(btn, d.variants, d.options);
    }).catch(function (err) {
      btn.removeAttribute('data-state');
      console.warn('[amatora-variants-sheet]', err);
      if (btn.dataset.productUrl) window.location.href = btn.dataset.productUrl;
    });
  }

  function show(btn, variants, options) {
    if (!variants.length) { if (btn.dataset.productUrl) window.location.href = btn.dataset.productUrl; return; }
    variants.forEach(function (v) { if (!Array.isArray(v.options)) v.options = [v.title]; });
    if (!options.length) {
      options = [{ name: 'Opción', values: variants.map(function (v) { return v.options[0]; }) }];
    }
    var first = variants.filter(function (v) { return v.available; })[0] || variants[0];
    // No se muestran valores sin ninguna variante disponible (p. ej. "Nacional" agotado);
    // si una opción queda con un solo valor, se presenta como texto informativo.
    if (first.available) {
      options = options.map(function (o, idx) {
        return {
          name: o.name,
          values: o.values.filter(function (val) {
            return variants.some(function (v) { return v.available && v.options[idx] === val; });
          })
        };
      });
    }

    state = {
      options: options,
      variants: variants,
      sel: first.options.slice(),
      url: btn.dataset.productUrl || '#',
      handle: handleOf(btn.dataset.productUrl),
      trim: btn.hasAttribute('data-money-trim'),
      shape: (btn.dataset.shape || 'rect').trim(),
      fallbackImg: null
    };
    // Imagen del producto como respaldo si la variante no trae la suya
    state.fallbackImg = btn.dataset.productImage || null;
    titleEl.textContent = btn.dataset.productTitle || '';
    lastTrigger = btn;
    render();

    clearTimeout(closeTimer);
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      var first = optsEl.querySelector('[aria-checked="true"]') || panel.querySelector('[data-amv-close].amv-am__x');
      (first || panel).focus({ preventScroll: true });
    });
  }

  function close(restoreFocus) {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var trigger = lastTrigger;
    lastTrigger = null;
    closeTimer = setTimeout(function () {
      root.hidden = true;
      if (restoreFocus !== false && trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
    }, 220);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var trigger = t.closest('[data-am-variants]');
    if (trigger && !root.contains(trigger)) { e.preventDefault(); open(trigger); return; }
    if (!root.contains(t)) return;
    if (t.closest('[data-amv-close]')) { close(); return; }
    var opt = t.closest('[data-idx]');
    if (opt) choose(Number(opt.dataset.idx), opt.dataset.value);
  });

  root.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    // Flechas dentro de un radiogroup
    var cur = e.target instanceof Element ? e.target.closest('[role="radio"]') : null;
    if (cur && /^Arrow(Left|Right|Up|Down)$/.test(e.key)) {
      var radios = Array.prototype.slice.call(cur.parentNode.querySelectorAll('[role="radio"]'));
      var i = radios.indexOf(cur);
      var next = radios[(i + (/Right|Down/.test(e.key) ? 1 : -1) + radios.length) % radios.length];
      e.preventDefault();
      choose(Number(next.dataset.idx), next.dataset.value);
      return;
    }
    // Trampa de foco
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(panel.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]'), function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var firstF = f[0], lastF = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === firstF || document.activeElement === panel)) { e.preventDefault(); lastF.focus(); }
      else if (!e.shiftKey && document.activeElement === lastF) { e.preventDefault(); firstF.focus(); }
    }
  });

  // Al agregar, el cart drawer toma el relevo (sin devolver el foco a la card)
  document.addEventListener('amatora:cart:added', function () { close(false); });
})();
